import { render, staticRenderFns } from "./merchantView.vue?vue&type=template&id=331da91c&scoped=true&"
import script from "./merchantView.vue?vue&type=script&lang=js&"
export * from "./merchantView.vue?vue&type=script&lang=js&"
import style0 from "./merchantView.vue?vue&type=style&index=0&id=331da91c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331da91c",
  null
  
)

export default component.exports